<div class="btn-group mt-3 tabs-over-graph">
  <button
    (click)="setGraphType(TRAFIC)"
    [disabled]="isLoading"
    class="btn btn-md waves-effect waves-light"
    [ngClass]="{ 'btn-inverse': graphType == TRAFIC }"
    type="button"
    [disabled]="!graphsRendered.overTime"
    [innerHTML]="'Traffic' | translate"
  ></button>
  <button
    (click)="setGraphType(RESPONSE_TIME)"
    [disabled]="isLoading"
    class="btn btn-md waves-effect waves-light"
    [ngClass]="{ 'btn-inverse': graphType == RESPONSE_TIME }"
    type="button"
    [disabled]="!graphsRendered.overTime"
    [innerHTML]="'ResponseTime' | translate"
  ></button>
  <button
    (click)="setGraphType(RESPONSES_CODES)"
    [disabled]="isLoading"
    class="btn btn-md waves-effect waves-light"
    [ngClass]="{ 'btn-inverse': graphType == RESPONSES_CODES }"
    type="button"
    [disabled]="!graphsRendered.overTime"
    [innerHTML]="'StatusCodes' | translate"
  ></button>
  <button
    (click)="setGraphType(BANDWIDTH)"
    [disabled]="isLoading"
    class="btn btn-md waves-effect waves-light"
    [ngClass]="{ 'btn-inverse': graphType == BANDWIDTH }"
    type="button"
    [disabled]="!graphsRendered.overTime"
    [innerHTML]="'BandwidthReport.title' | translate"
  ></button>
</div>
<div class="card with-tabs p-0 m-0">
  <div class="container-log-panels">
    <div #graphOverTimePanel class="log-panel left-log-panel m-0 position-relative">
      <div class="flex-align-items position-relative">
        <div class="btn-group ml-auto">
          <button
            class="btn btn-sm btn-square waves-effect waves-light"
            (click)="zoomOut()"
            [title]="'ZoomOut' | translate"
            [disabled]="
              !graphsRendered.overTime ||
              (disableGoForward(sites[ctx].current.period.range.end) &&
                disableGoBack(sites[ctx].current.period.range.start))
            "
            style="border-top-left-radius: 0"
          >
            {{ 'ZoomOut' | translate }} <i class="icofont icofont-ui-zoom-out ml-1"></i>
          </button>
          <button
            class="btn btn-sm btn-square waves-effect waves-light"
            (click)="strafe('left')"
            [disabled]="!graphsRendered.overTime || disableGoBack(sites[ctx].current.period.range.start)"
            [title]="'StrafeLeft' | translate"
          >
            <
          </button>
          <button
            style="border-right: none"
            class="btn btn-sm btn-square waves-effect waves-light"
            (click)="strafe('right')"
            [disabled]="!graphsRendered.overTime || disableGoForward(sites[ctx].current.period.range.end)"
            [title]="'StrafeRight' | translate"
          >
            >
          </button>
        </div>
      </div>
      @if (chartInterval) {
      <div class="chart-interval">{{ 'Graph.interval' | translateLabel }} {{ chartInterval | durationSeconds }}</div>
      }
      <app-graph
        [hidden]="!graphsRendered.overTime"
        [data]="graphOverTimeData[graphType]"
        [clickableType]="clickableTypes[graphType]"
        (zoneSelected)="onPeriodEmittedFromZoneSelected($event)"
        (columnClicked)="onColumnClick($event)"
        (isRendered)="graphsRendered.overTime = true"
      />
      <ogo-spinner [hidden]="graphsRendered.overTime" [inline]="true" [margin]="'7rem 0'"></ogo-spinner>
      <div class="chart-total">
        @if (totalRequests !== null) {
          <div>{{ 'Requests.number' | translateLabel}} {{ totalRequests | number }}</div>
        }
        @if (graphType == 'bandwidth' && totalBandwidth!==null) {
          <div>{{ 'BandwidthReport.total' | translateLabel }} {{ totalBandwidth | size }}</div>
        }
      </div>
    </div>
    <div #breakdownsPanel class="log-panel right-log-panel m-0">
      <div class="p-t-2 flex-align-items">
        <div #breakdownGraphsContainer class="breakdown-container flex-align-items">
          <div class="arrow-container" [title]="'Minimize' | translate" (click)="toggleBreakdownsPanel()">
            <i class="icofont icofont-arrow-right flex-align-items"></i>
          </div>
          <div #breakdownGraphs class="breakdown-graph position-relative">
            <div *ngIf="graphType == TRAFIC" class="btn-group mb-3">
              <button
                *ngFor="let type of BreakdownsByGraphType[graphType]"
                (click)="setBreakdownType(type)"
                class="btn btn-sm btn-square waves-effect waves-light"
                style="border-top-left-radius: 0"
                [ngClass]="{ 'btn-inverse': breakdownType == type }"
                type="button"
              >
                <i class="icofont icofont-long-arrow-down"></i>
                {{ 'Graph.breakdown.' + type | translate }}
              </button>
            </div>
            <div *ngIf="graphType == RESPONSE_TIME" class="btn-group mb-3">
              <button
                *ngFor="let type of BreakdownsByGraphType[graphType]"
                (click)="setBreakdownType(type)"
                class="btn btn-sm btn-square waves-effect waves-light"
                style="border-top-left-radius: 0"
                [ngClass]="{ 'btn-inverse': breakdownType == type }"
                type="button"
              >
                <i class="icofont icofont-long-arrow-down"></i>
                {{ 'Graph.breakdown.' + type | translate }}
              </button>
            </div>
            <div *ngIf="graphType == BANDWIDTH" class="btn-group mb-3">
              <button
                *ngFor="let type of BreakdownsByGraphType[graphType]"
                (click)="setBreakdownType(type)"
                class="btn btn-sm btn-square waves-effect waves-light"
                style="border-top-left-radius: 0"
                [ngClass]="{ 'btn-inverse': breakdownType == type }"
                type="button"
              >
                <i class="icofont icofont-long-arrow-down"></i>
                {{ 'Graph.breakdown.' + type | translate }}
              </button>
            </div>
            <app-bar-horizontal
              [hidden]="!graphsRendered.breakdown"
              class="bar-horizontal-{{ breakdownType }}"
              [data]="breakdownsData[breakdownType]"
              (barClicked)="breakdownBarClicked($event)"
              (categoryClicked)="breakdownCategoryClicked($event)"
              (isRendered)="graphsRendered.breakdown = true"
            ></app-bar-horizontal>
            <ogo-spinner [hidden]="graphsRendered.breakdown" [inline]="true" [margin]="'7rem 0'"></ogo-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
